import french from '../aica-web-data/language.french.json';
import english from '../aica-web-data/language.english.json';

const LANGUAGE_PACKS = {
  fr: french,
  en: english,
};

function normalizePage(ns) {
  if (!ns) return { data: {}, strings: {} };
  if (ns.strings || ns.data) {
    return { data: ns.data || {}, strings: ns.strings || {} };
  }
  // flat namespace (common, services, seo)
  return { data: {}, strings: ns };
}

export function getLanguagePack(lang = 'fr') {
  return LANGUAGE_PACKS[lang === 'en' ? 'en' : 'fr'] || LANGUAGE_PACKS.fr;
}

export function getNamespace(namespace, lang = 'fr') {
  const pack = getLanguagePack(lang);
  return pack[namespace] || {};
}

export function getPageContent(pageId, lang = 'fr') {
  return normalizePage(getNamespace(pageId, lang));
}

export function getPageData(pageId, lang = 'fr') {
  return getPageContent(pageId, lang).data || {};
}

export function getPageStrings(pageId, lang = 'fr') {
  return getPageContent(pageId, lang).strings || {};
}

export function tKey(namespace, key, lang = 'fr') {
  const ns = getNamespace(namespace, lang);
  if (ns && typeof ns === 'object') {
    if (ns.strings && ns.strings[key] != null) return ns.strings[key];
    if (ns[key] != null && typeof ns[key] === 'string') return ns[key];
  }
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.warn(`[i18n] missing ${lang}.${namespace}.${key}`);
  }
  return '';
}

export { LANGUAGE_PACKS };
